<script setup lang="ts">
import DialogCloseBtn from '@core/components/DialogCloseBtn.vue'
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
  },
  message: {
    type: String,
  },
  confirmBtnText: {
    type: String,
    default: 'Confirm',
  },
  cancelBtnText: {
    type: String,
    default: 'Cancel',
  },
  onConfirm: {
    type: Function,
  },
  onCancel: {
    type: Function,
  },
  isDialogVisible: {
    type: Boolean,
    required: true,
  },
  confirmationBtnColor: {
    type: String,
    default: 'primary',
  },
  confBtnProps: {
    type: Object,
    default: () => ({}),
  },
})
const emit = defineEmits([
  'update:modelValue',
  'confirmAction',
  'cancelAction',
  'update:isDialogVisible',
])

const dialogModelValueUpdate = (val: boolean) => {
  emit('update:isDialogVisible', val)
}
const cancel = () => {
  dialogModelValueUpdate(false)
  props.onCancel && props.onCancel()
  emit('cancelAction')
}
const confirm = () => {
  props.onConfirm?.()
  dialogModelValueUpdate(false)
  emit('confirmAction')
}

const allowedConfirmationButtonColors = [
  'primary',
  'error',
  'success',
  'warning',
  'info',
]
const confirmationButtonColor = computed(() => {
  if (allowedConfirmationButtonColors.includes(props.confirmationBtnColor)) {
    return props.confirmationBtnColor
  } else {
    return 'primary'
  }
})
</script>

<template>
  <VDialog
    v-bind="$attrs"
    width="auto"
    :model-value="isDialogVisible"
    @update:model-value="dialogModelValueUpdate"
  >
    <DialogCloseBtn @click="dialogModelValueUpdate(false)" />
    <VCard class="pa-sm-8 pa-4 py-sm-14">
      <VCardTitle class="v-card-title text-center" style="font-weight: 600">
        {{ title ?? 'Confirm Action' }}
      </VCardTitle>
      <VCardText>
        {{ message ?? 'Are you sure you want to perform this operation?' }}
      </VCardText>
      <VSpacer />
      <div style="margin-top: 16px" class="d-flex justify-center gap-4">
        <VBtn
          id="dialog-cancel-btn"
          min-width="100px"
          color="primary"
          elevation="0"
          variant="outlined"
          :style="{
            backgroundColor: `var(--v-textfields-bg)`,
          }"
          @click="cancel"
        >
          {{ cancelBtnText }}
        </VBtn>
        <VBtn
          v-bind="confBtnProps"
          id="dialog-confirm-btn"
          :color="confBtnProps?.color || 'main-primary'"
          :variant="confBtnProps?.variant || 'elevated'"
          min-width="130px"
          elevation="0"
          @click="confirm"
        >
          <span
            :style="{
              color: `rgb(var(--v-theme-on-${
                confBtnProps.color || 'main-primary'
              }))`,
            }"
          >
            {{ confirmBtnText }}
          </span>
        </VBtn>
      </div>
    </VCard>
  </VDialog>
</template>
<style scoped></style>
